import { Action, createReducer, on } from '@ngrx/store';
import { produce } from 'immer';
import { Employee } from 'src/app/model/employee';
import * as EmployeeActions from '../actions/employee.actions';

export const employeeFeatureKey = 'employee';

export interface State {
  loggedInemployee: Employee;
}

export const initialState: State = {
  loggedInemployee: new Employee()
};

export const reducer = createReducer(
  initialState,

  on(EmployeeActions.loadEmployee, state => state),
  on(EmployeeActions.loadEmployeeSuccess, (state, action) => {
    return produce(state, (draftState) => {
      draftState.loggedInemployee = action.loggedInemployee;
    });
  }),
  on(EmployeeActions.loadEmployeeFailure, (state, action) => state),

);
